import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDot = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 7,
	height: 7,
	viewBox: "0 0 7 7",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("circle", {
		cx: 3.5,
		cy: 3.5,
		r: 3,
		fill: "currentColor"
	})
});
export default SvgDot;
